import type { FC } from "react";

import {
  Box,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RulesTabActualVisitorsCaseProps {
  minNumberOfVisitors?: number;
  withRepeat: boolean;
  onChangeMinNumberOfVisitors?: (value: number) => void;
  onToggleWithRepeat: () => void;
}

export const RulesTabActualVisitorsCase: FC<
  RulesTabActualVisitorsCaseProps
> = ({
  minNumberOfVisitors,
  withRepeat,
  onToggleWithRepeat,
  onChangeMinNumberOfVisitors,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack sx={{ py: 2 }}>
      <Box>
        <Stack direction='row' alignItems='center'>
          <TextField
            sx={{ width: 1 }}
            label={t(
              "campaign.notifications.settings.displayRules.actualVisitors.maxVisitors",
            )}
            type='number'
            variant='outlined'
            value={minNumberOfVisitors}
            onChange={e =>
              onChangeMinNumberOfVisitors &&
              onChangeMinNumberOfVisitors(Number(e.target.value))
            }
            InputProps={{
              inputProps: { min: 0, style: { height: 10 } },
              endAdornment: (
                <InputAdornment position='end'>
                  <Typography
                    style={{
                      color: theme.palette.natural.t1,
                      fontSize: 14,
                    }}
                  >
                    {t(
                      "campaign.notifications.settings.displayRules.actualVisitors.visitors",
                    )}
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography color={theme.palette.natural.t1} fontSize={14}>
            {t(
              "campaign.notifications.settings.displayRules.repeatNotification",
            )}
          </Typography>
          <CustomSwitch checked={withRepeat} onSwitch={onToggleWithRepeat} />
        </Stack>
      </Box>
    </Stack>
  );
};
